export default __webpack_public_path__ + "static/media/rhs.09025530.png";